/*
 * konami.js: Konami Code implementation.
 *
 * LICENSE:
 * Copyright (c) 2013, Evilham (https://evilham.com)
 * BSD 2-Clause copyright and disclaimer apply.
 *
 */

var konami=konami||{
  //Turns out, Intro is not part of the code o.ô
  code: [38,38,40,40,37,39,37,39,66,65],//,13],
  nextKey: 0,
  action: function(){},
};
konami.kdhandle=(function(scope){
  return function(e) {
    e=e||event;
    if (e.keyCode==scope.code[scope.nextKey])
      scope.nextKey+=1;
    else {
      // Use this "failed" key press if it's the first one of the code.
      if (e.keyCode==scope.code[0])
        scope.nextKey=1;
        scope.nextKey=0;
    }
    if (scope.code.length==scope.nextKey)
      scope.action();
  }})(konami);
window.addEventListener("keydown", konami.kdhandle, false);

module.exports = konami;
